export default "__VITE_ASSET__vxeVQzR0__"